/*
  Añadir al carrito con varias líneas: variantes por unidad + upsells.

  El formulario de producto de Dawn envía una sola línea (name="id" +
  name="quantity"). Este tema necesita más:
    - <quantity-breaks> permite elegir una variante distinta por unidad
      (Oro, Oro, Plata) → 3 líneas diferentes.
    - upsell-custom.liquid pinta checkboxes .upsell-checkbox con data-variant-id
      que deben añadirse junto al producto principal.

  Ambas lógicas venían en el bundle con licencia y se perdieron.

  Estrategia: no se reimplementa el envío. Se ajusta el formulario justo antes
  de que product-form.js lo lea, inyectando inputs items[N][id] / items[N][quantity]
  y desactivando los inputs de línea única. Así se sigue aprovechando todo lo que
  Dawn ya hace: mensajes de error, renderizado de las secciones del carrito,
  apertura del cajón y publish(PUB_SUB_EVENTS.cartUpdate).
*/
(function () {
  var INJECTED = 'data-cart-extras-injected';

  function isProductForm(form) {
    return !!(form && form.matches && form.matches('form[action*="/cart/add"]'));
  }

  function collectVariantIds(form) {
    // <quantity-breaks> deja aquí los ids del tramo activo, uno por unidad.
    var holder =
      form.querySelector('.product-form__variants') ||
      document.querySelector('.product-form__variants');
    if (!holder || !holder.dataset.values) return [];
    return holder.dataset.values
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
  }

  function collectUpsells() {
    // :not(#CartDrawer *) es imprescindible. El cart drawer se pinta en
    // theme.liquid dentro del <body> de TODAS las paginas, y su toggle de upsell
    // vive ahi con el checkbox marcado cuando el producto ya esta en el carrito.
    // Con un querySelectorAll global, cada add-to-cart de una ficha de producto
    // colaba tambien el upsell del carrito como linea extra.
    // El markup del drawer usa ademas la clase cart-upsell__checkbox, asi que
    // esto es la segunda barrera, no la unica.
    var boxes = document.querySelectorAll('.upsell-checkbox:checked:not(#CartDrawer *)');
    return Array.prototype.map.call(boxes, function (box) {
      return {
        id: box.dataset.variantId,
        sellingPlan: box.dataset.sellingPlanId || ''
      };
    }).filter(function (item) {
      return !!item.id;
    });
  }

  // Varias unidades de la misma variante se agrupan en una línea, que es como
  // lo mostraría el carrito de todos modos.
  function groupById(ids) {
    var order = [];
    var counts = {};
    ids.forEach(function (id) {
      if (counts[id] === undefined) {
        counts[id] = 0;
        order.push(id);
      }
      counts[id]++;
    });
    return order.map(function (id) {
      return { id: id, quantity: counts[id] };
    });
  }

  function cleanup(form) {
    var stale = form.querySelectorAll('[' + INJECTED + ']');
    Array.prototype.forEach.call(stale, function (node) {
      node.remove();
    });
    var disabled = form.querySelectorAll('[data-cart-extras-disabled]');
    Array.prototype.forEach.call(disabled, function (node) {
      node.disabled = false;
      node.removeAttribute('data-cart-extras-disabled');
    });
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(INJECTED, '');
    form.appendChild(input);
  }

  function onSubmitCapture(event) {
    var form = event.target;
    if (!isProductForm(form)) return;

    // Restos de un envío anterior: si no se limpian, el segundo clic
    // duplicaría líneas.
    cleanup(form);

    var lines = groupById(collectVariantIds(form));
    var upsells = collectUpsells();

    // Una sola línea y sin upsells: el flujo normal de Dawn ya es correcto.
    if (lines.length <= 1 && upsells.length === 0) return;

    // Si quantity-breaks no publicó nada (producto sin selectores), se conserva
    // la línea principal tal cual la tenía el formulario.
    if (!lines.length) {
      var mainId = form.querySelector('input[name="id"]');
      var mainQty = form.querySelector('[name="quantity"]:checked') || form.querySelector('[name="quantity"]');
      if (mainId && mainId.value) {
        lines = [{ id: mainId.value, quantity: parseInt(mainQty && mainQty.value, 10) || 1 }];
      }
    }

    var index = 0;
    lines.forEach(function (line) {
      addHidden(form, 'items[' + index + '][id]', line.id);
      addHidden(form, 'items[' + index + '][quantity]', line.quantity);
      index++;
    });

    upsells.forEach(function (item) {
      addHidden(form, 'items[' + index + '][id]', item.id);
      addHidden(form, 'items[' + index + '][quantity]', 1);
      if (item.sellingPlan) {
        addHidden(form, 'items[' + index + '][selling_plan]', item.sellingPlan);
      }
      // Marca la linea como upsell para que el carrito pueda ponerla debajo del
      // producto principal. Shopify no respeta el orden del array cuando se
      // anaden varias lineas en una sola peticion, asi que el orden se decide
      // al pintar el carrito, no aqui. El guion bajo la oculta al cliente.
      addHidden(form, 'items[' + index + '][properties][_upsell]', 'true');
      index++;
    });

    // Con items[] presentes, un id/quantity sueltos confundirían a /cart/add.
    // disabled = true hace que FormData los ignore sin alterar la interfaz.
    var singles = form.querySelectorAll('input[name="id"], [name="quantity"]');
    Array.prototype.forEach.call(singles, function (node) {
      if (node.disabled) return;
      node.disabled = true;
      node.setAttribute('data-cart-extras-disabled', '');
    });

    // Devolver el formulario a su estado normal en cuanto Dawn haya construido
    // su FormData (lo hace de forma síncrona dentro de su propio handler).
    setTimeout(function () {
      cleanup(form);
    }, 0);
  }

  // En el elemento objetivo los listeners se ejecutan en orden de registro, así
  // que capturar sobre el propio <form> no garantiza ir antes que product-form.js.
  // Escuchando en document durante la fase de captura sí se llega primero.
  document.addEventListener('submit', onSubmitCapture, true);
})();
